import React, { Component } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Loader } from 'components';
import CallBack from 'components/Auth/CallBack';
import Login from 'components/Auth/Login';
import Home from 'pages/Home';
import authCognito from 'services/cognito/lib';
import LogoutComponent from 'components/Auth/Logout';

const StyledLoader = styled(Loader)`
    margin-top: ${({ theme }) => theme.height.header}px;
    height: calc(100vh - ${({ theme }) => theme.height.header}px);
`;

class RouterComponent extends Component<{}, { loading: boolean; isAuthenticated: boolean }> {
    state = { loading: true, isAuthenticated: false };

    checkSession = async () => {
        try {
            const isAuthenticated = await authCognito.isAuthenticated();
            this.setState({
                isAuthenticated,
            });
        } catch (error) {
            this.setState({
                isAuthenticated: false,
            });
        } finally {
            this.setState({
                loading: false,
            });
        }
    };

    async componentDidMount() {
        this.checkSession();
    }

    render() {
        // If still loading, show loader
        if (this.state.loading) {
            return <StyledLoader />;
        }

        return (
            <Router>
                {/* We use a Routes component to handle authentication logic */}
                <AppRoutes isAuthenticated={this.state.isAuthenticated} />
            </Router>
        );
    }
}

// Separate component for routes to ensure we can use router hooks
const AppRoutes: React.FC<{ isAuthenticated: boolean }> = ({ isAuthenticated }) => {
    const location = useLocation();

    // Define public paths
    const publicPaths = ['/login', '/callback', '/logout', '/password-expired'];
    const isPublicPath = (path: string) => publicPaths.some((p) => path.startsWith(p));

    // Check if current path is public
    const currentIsPublic = isPublicPath(location.pathname);

    // If user is not authenticated and trying to access a protected route
    if (!isAuthenticated && !currentIsPublic) {
        return (
            <Navigate
                to={{
                    pathname: '/login',
                }}
            />
        );
    }

    // Regular routing for authenticated users or public paths
    return (
        <Routes>
            {/* Public routes */}
            {/* <Route path="/password-expired" Component={PasswordExpired} /> */}
            <Route path="/login" Component={Login} />
            <Route path="/callback" Component={CallBack} />
            <Route path="/logout" Component={LogoutComponent} />

            {/* Protected route - for authenticated users only */}
            <Route path="/" Component={Home} />

            {/* Default route */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default RouterComponent;
